/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_BrandInputs */

const cs_settings_office_brand = /** @type {(inputs: Settings_Office_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Značka`)
};

const en_settings_office_brand = /** @type {(inputs: Settings_Office_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand`)
};

/**
* | output |
* | --- |
* | "Brand" |
*
* @param {Settings_Office_BrandInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_brand = /** @type {((inputs?: Settings_Office_BrandInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_BrandInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_brand(inputs)
	return cs_settings_office_brand(inputs)
});